import React, { useState,useEffect } from "react";
import { Input, FormGroup, Label, Button, Row, Col } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import axios from "axios";
import "../../../src/styles/style.css";
import { toast } from "react-toastify";

import { getAdditionalFields,getSubAdditionalFields,getSubSubAdditionalFields,getBookingTimingFormData, getTicketSubType, getTicketSubSubType, deleteTimings, getTicketType} from "../../redux/actions/indexActions";
import AdditionalFormFields from "./AdditionalFormFields";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
const Timings = ({ticketSubType,placeId}) => {
    const dispatch = useDispatch();
    const { auth } = useSelector((state) => state.AuthReducer);
    const { indexReducer: { TicketTypeList, TicketSubTypeList,TicketSubSubTypeList,bookingCategoriesList,bookingSubCategoriesList,bookingTimingForm,bookingTimings} } = useSelector((state) => state);
    const [errors, setErrors] = useState({});
    const [visitorDetails, setVisitorDetails] = useState(false);
    const [secVisitorDetails, setSecVisitorDetails] = useState(false);
    const [parentSlots, setParentSlots] = useState([]);
    
    const [state, setState] = useState({
        additionalField:0,
        subAdditionalField:0,
        subSubAdditionalField:0,
        is_ticket_type:0,
        is_ticket_sub_type:0,
        is_ticket_sub_sub_type:0,
        is_attech_document:0,
        ticket_type:"",
        ticket_sub_type:"",
        ticket_sub_sub_type:"",
        group_booking_type:"",
        sub_group_booking_type:"",
        sub_sub_group_booking_type:"",
        full_name:0,
        age:0,
        gender:0,
        id_type:0,
        id_no:0,
        upload_capture:0,
        country:0,
        state:0,
        address:0,
        pin_code:0,
        slot_timing:0,
        single_time:0,
        closed:0,
        full_day:0,
        showTiming:0,
        per_day_slots:0,
        schedules:0,
        is_full_day:0,
        is_till_time:0,
        till_time:0,
        from_timing:0,
        is_advence_booking:0,
        adv_start_date:'',
        adv_end_date:'',
        place_id:placeId,
        showCalendar:0,
        showTicketTiming:0,
        time_frame:"",
        time_frame_type:"Days",
    });

    useEffect(()=>{
        if(bookingTimingForm && Object.keys(bookingTimingForm).length > 0){
            dispatch(getTicketSubType(auth?.token,bookingTimingForm.ticket_type));
            dispatch(getTicketSubSubType(auth.token, bookingTimingForm.ticket_sub_type));
            setState((prev) => ({
                ...prev,
                showTiming: bookingTimingForm.is_show_timing,
                seasonalTiming: bookingTimingForm.is_seasonal_timing,
                schedules: bookingTimingForm.is_schedules,
                per_day_slots: bookingTimingForm.is_slots,
                showCalendar: bookingTimingForm.is_calendar,
                showTicketTiming: bookingTimingForm.is_ticket_booking_time,
                is_full_day: bookingTimingForm.is_full_day,
                is_till_time: bookingTimingForm.is_till_timing,
                till_time: bookingTimingForm.till_timing,
                from_timing: bookingTimingForm.from_timing,
                is_advence_booking: bookingTimingForm.is_advance_booking,
                adv_start_date: bookingTimingForm.advance_booking_start_date,
                adv_end_date: bookingTimingForm.advance_booking_end_date,
                place_id: bookingTimingForm.place_id,
                ticket_type: bookingTimingForm.ticket_type,
                ticket_sub_type: bookingTimingForm.ticket_sub_type,
                ticket_sub_sub_type: bookingTimingForm.ticket_sub_sub_type,
                is_ticket_type: bookingTimingForm.is_ticket_type,
                is_ticket_sub_type: bookingTimingForm.is_ticket_sub_type,
                is_ticket_sub_sub_type: bookingTimingForm.is_ticket_sub_sub_type,
                time_frame: bookingTimingForm.time_frame,
                time_frame_type: bookingTimingForm.time_frame_type,
            }));
        }
        // console.log('bookingTimingForm-->>>',bookingTimingForm)
    },[bookingTimingForm]);

    useEffect(()=>{
        dispatch(getBookingTimingFormData(auth?.token,placeId));
        dispatch(getTicketType(auth?.token,placeId));
    },[placeId]);


     // Additional Fields
     const [additionalFieldInput, setAdditionalFieldInput] = useState([{ field_type_id: '', name:''}]);

     const addAdditionalFieldInput = () => {
         setAdditionalFieldInput((prev) => [...prev, { field_type_id: "", name: "" }]);
     };
 
     const removeAdditionalFieldInput = (index) => {
         if (additionalFieldInput.length > 1) {
             setAdditionalFieldInput((prev) => prev.filter((_, i) => i !== index));
         }
     };
 
     const handleAdditionalInputChange = (index,field,value,type) => {
         setAdditionalFieldInput((prev) => {
           const newFields = prev.map((item, i) =>
             i === index ? { ...item, [field]: value } : item
           );
           const updatedItem = newFields[index];
           if(updatedItem.name !=''){
             newFields[index] = { ...updatedItem, field_type_id: state.ticket_type,place_id:placeId,type:type};
           }
           return newFields;
         });
     };
  
     const handleAdditionalSubmit = () => {
         const formData = new FormData();
         additionalFieldInput.forEach((item, index) => {
             if(item.name !== "" && item.field_type_id !== "" ) {
                 formData.append(`additional_fields[${index}][field_type_id]`, item.field_type_id);
                 formData.append(`additional_fields[${index}][name]`, item.name);
                 formData.append(`additional_fields[${index}][place_id]`, item.place_id);
                 formData.append(`additional_fields[${index}][type]`, item.type);
             }
         });
         axios.post(`/api/admin/v1/add-additional-field`, formData, {
             headers: {
                 "Content-Type": "multipart/form-data",
                 Authorization: `Bearer ${auth?.token}`,
             },
         }).then((res) => {
             toast.success(res.data?.message);
             dispatch(getAdditionalFields(auth.token,placeId,state.ticket_type));
         }).catch((err) => {
             toast.error(err.response.data?.message || "An error occurred");
             setErrors(err.response.data);
         });
     };
 
     const [subAdditionalInput, setSubAdditionalInput] = useState([{ field_type_id: '',additional_field_id: '', name: ''}]);
 
     const addSubAdditionalFieldInput = () => {
         setSubAdditionalInput((prev) => [...prev, { field_type_id: "",additional_field_id: "", name: "" }]);
     };
 
     const removeSubAdditionalFieldInput = (index) => {
         if (subAdditionalInput.length > 1) {
             setSubAdditionalInput((prev) => prev.filter((_, i) => i !== index));
         }
     };
 
 
     const handleSubAdditionalInputChange = (index, field, value,type) => {
         setSubAdditionalInput((prev) => {
           const newFields = prev.map((item, i) =>
             i === index ? { ...item, [field]: value } : item
           );
           const updatedItem = newFields[index];
           if(updatedItem.name !=''){
             newFields[index] = { ...updatedItem,
                 field_type_id:state.ticket_type,
                 additional_field_id: state.ticket_sub_type,
                 place_id:placeId,
                 type:type,
             };
           }
           return newFields;
         });
     };
 
     const handleSubAdditionalSubmit = () => {
         const formData = new FormData();
         subAdditionalInput.forEach((item, index) => {
             if(item.name !== "" && item.additional_field_id !== "") {
                 formData.append(`sub_additional_fields[${index}][field_type_id]`, item.field_type_id);
                 formData.append(`sub_additional_fields[${index}][additional_field_id]`, item.additional_field_id);
                 formData.append(`sub_additional_fields[${index}][name]`, item.name);
                 formData.append(`sub_additional_fields[${index}][place_id]`, item.place_id);
                 formData.append(`sub_additional_fields[${index}][type]`, item.type);
             }
         });
         axios.post(`/api/admin/v1/add-sub-additional-field`, formData, {
             headers: {
                 "Content-Type": "multipart/form-data",
                 Authorization: `Bearer ${auth?.token}`,
             },
         }).then((res) => {
             toast.success(res.data?.message);
             dispatch(getSubAdditionalFields(auth.token,placeId,state.ticket_sub_type));
         }).catch((err) => {
             toast.error(err.response.data?.message || "An error occurred");
             setErrors(err.response.data);
         });
     };
 
     // Sub Sub Additional Fields
     const [subSubAdditionalInput, setSubSubAdditionalInput] = useState([{ field_type_id: '',additional_field_id: '',sub_additional_field_id:'', name: ''}]);
 
     const addSubSubAdditionalFieldInput = () => {
         setSubSubAdditionalInput((prev) => [...prev, { field_type_id: '',additional_field_id: '',sub_additional_field_id:'', name: "" }]);
     };
 
     const removeSubSubAdditionalFieldInput = (index) => {
         if (subSubAdditionalInput.length > 1) {
             setSubSubAdditionalInput((prev) => prev.filter((_, i) => i !== index));
         }
     };
 
     const handleSubSubAdditionalInputChange = (index, field, value, type) => {
         setSubSubAdditionalInput((prev) => {
           const newFields = prev.map((item, i) =>
             i === index ? { ...item, [field]: value } : item
           );
           const updatedItem = newFields[index];
           if(updatedItem.name !=''){
             newFields[index] = { ...updatedItem, 
                 field_type_id:state.ticket_type,
                 additional_field_id: state.ticket_sub_type,
                 sub_additional_field_id: state.ticket_sub_sub_type,
                 place_id:placeId, 
                 type:type, 
             };
           }
           return newFields;
         });
     };
 
     const handleSubSubAdditionalSubmit = () => {
         const formData = new FormData();
         subSubAdditionalInput.forEach((item, index) => {
             if(item.name !== "" && item.sub_additional_field_id !== "") {
                 formData.append(`sub_sub_additional_fields[${index}][field_type_id]`, item.field_type_id);
                 formData.append(`sub_sub_additional_fields[${index}][additional_field_id]`, item.additional_field_id);
                 formData.append(`sub_sub_additional_fields[${index}][sub_additional_field_id]`, item.sub_additional_field_id);
                 formData.append(`sub_sub_additional_fields[${index}][name]`, item.name);
                 formData.append(`sub_sub_additional_fields[${index}][place_id]`, item.place_id);
                 formData.append(`sub_sub_additional_fields[${index}][type]`, item.type);
             }
         });
         axios.post(`/api/admin/v1/add-sub-sub-additional-field`, formData, {
             headers: {
                 "Content-Type": "multipart/form-data",
                 Authorization: `Bearer ${auth?.token}`,
             },
         }).then((res) => {
             toast.success(res.data?.message);
             dispatch(getSubAdditionalFields(auth.token,placeId,state.ticket_sub_type));
         }).catch((err) => {
             toast.error(err.response.data?.message || "An error occurred");
             setErrors(err.response.data);
         });
     };
 
 
 
      // Seasonal Timing
    const [seasonalTiming, setSeasonalTiming] = useState([{ 
        is_seasonal:0,
        start_time: '',
        end_time: '',
        start_date:'',
        end_date:'',
    }]);

    const addSeasonalTiming = () => {
        setSeasonalTiming((prev) => [...prev, { start_time: '',end_time: '',start_date:'',end_date:''}]);
    };

    const removeSeasonalTiming = (index) => {
        if (seasonalTiming.length > 1) {
            setSeasonalTiming((prev) => prev.filter((_, i) => i !== index));
        }
    };

    const handleSeasonalTiming = (index, field, value) => {
        setSeasonalTiming((prev) => {
            const newFields = prev.map((item, i) =>
                i === index 
                ? { 
                    ...item, 
                    [field]: value,  
                    is_seasonal: field === 'is_seasonal' ? value : state.seasonalTiming
                } 
                : item
            );
            return newFields;
        });
    };

    // Schedule Timing
    const [schedules, setSchedules] = useState([{ 
        is_schedule:0,
        schedule:'',
    }]);

    const addScheduleTiming = () => {
        setSchedules((prev) => [...prev, { is_schedule: '',schedule: ''}]);
    };

    const removeScheduleTiming = (index) => {
        if (schedules.length > 1) {
            setSchedules((prev) => prev.filter((_, i) => i !== index));
        }
    };

    const handleSchedule = (index, field, value) => {
        setSchedules((prev) => {
            const newFields = prev.map((item, i) =>
                i === index 
                ? { 
                    ...item, 
                    [field]: value,  
                    is_schedule: field === 'is_schedule' ? value : state.schedules
                } 
                : item
            );
            return newFields;
        });
    };

    // Slots Timing
    const [slots, setSlots] = useState([
        {
            is_slot:0,
            parent_id:0,
            custome_field:'',
            type:'period',
            sub_type:'',
            slot_from:'',
            slot_to:'',
            max_slot_bookings:'',
        },
        { 
            is_slot:0,
            parent_id:0,
            custome_field:'',
            type:'slots',
            sub_type:'',
            slot_from:'',
            slot_to:'',
            max_slot_bookings:'',
        },
        {
            is_slot:0,
            parent_id:0,
            custome_field:'',
            type:'vehicle_booking_period',
            sub_type:'',
            slot_from:'',
            slot_to:'', 
            max_slot_bookings:'',
        }
    ]);

    // console.log('slots =>',slots);

    const addSlotsTiming = (type) => {
        setSlots((prev) => [
            ...prev,
            {
                is_slot: 1,
                parent_id: 0,
                custome_field: "",
                type: type,
                sub_type: "",
                slot_from: "",
                slot_to: "",
                max_slot_bookings: "",
            },
        ]);
    };

    const removeSlotsTiming = (index,type) => {
        if(slots.filter(slot => slot.type === type).length > 1){
            setSlots((prev) => prev.filter((_, i) => i !== index ));
        }
    };

    const formatTime12h = (time24) => {
        if (!time24) return "";
        const [hourStr, minuteStr = "00"] = String(time24).split(":");
        let hour = parseInt(hourStr, 10);
        if (Number.isNaN(hour)) return "";
        const minute = String(parseInt(minuteStr, 10) || 0).padStart(2, "0");
        const period = hour >= 12 ? "PM" : "AM";
        hour = hour % 12 || 12;
        return `${String(hour).padStart(2, "0")}:${minute} ${period}`;
    };

    const buildSlotCustomeField = (slotFrom, slotTo) => {
        if (!slotFrom || !slotTo) return "";
        return `${formatTime12h(slotFrom)} - ${formatTime12h(slotTo)}`;
    };

    const handleSlots = (index, field, value) => {
        setSlots((prev) => {
            const newFields = prev.map((item, i) => {
                if (i !== index) return item;

                const updated = {
                    ...item,
                    [field]: value,
                    is_slot: field === 'is_slot' ? value : state.per_day_slots
                };

                if (item.type === 'slots' && (field === 'slot_from' || field === 'slot_to')) {
                    const slotFrom = field === 'slot_from' ? value : item.slot_from;
                    const slotTo = field === 'slot_to' ? value : item.slot_to;
                    updated.custome_field = buildSlotCustomeField(slotFrom, slotTo);
                }

                return updated;
            });
            return newFields;
        });
    };

    const [selectedDays, setSelectedDays] = useState([]); // instead of selectedDays

    const options = [
        { day: "Sunday", label: "SUN" },
        { day: "Monday", label: "MON" },
        { day: "Tuesday", label: "TUE" },
        { day: "Wednesday", label: "WED" },
        { day: "Thursday", label: "THU" },
        { day: "Friday", label: "FRI" },
        { day: "Saturday", label: "SAT" },
    ];
    const [timings, setTimings] = useState({
        day:"",
        full_day: 0,
        closed: 0,
        is_single_time: 0,
        is_slot_timing: 0,
        is_custom: 0,
        single_time:"",
        slot_start_time:"",
        slot_end_time:"",
        custom_value:"",
    });
    const [daysTiming, setDaysTiming] = useState([]);
    const handleAddTimingSubmit = () => {
        if (selectedDays.length === 0) {
            toast.error("Please select at least one day.");
            return;
        }
    
        if (timings.is_slot_timing === 1 && (!timings.slot_start_time || !timings.slot_end_time)) {
            toast.error("Please select start and end time.");
            return;
        }
    
        if (timings.is_single_time === 1 && !timings.single_time) {
            toast.error("Please select a time for single time option.");
            return;
        }
    
        if (timings.is_custom === 1 && timings.custom_value === "") {
            toast.error("Please fill the custom time field.");
            return;
        }
    
        // Check if at least one timing type is selected
        if (timings.full_day !== 1 && timings.closed !== 1 && 
            timings.is_single_time !== 1 && timings.is_slot_timing !== 1 && 
            timings.is_custom !== 1) {
            toast.error("Please select a timing type (24 hours, Closed, Single Time, Slot Timing, or Custom).");
            return;
        }
    
        // Allow multiple slots for the same day - removed duplicate check
    
        const newTimings = selectedDays.map(day => ({
            ...timings,
            day,
        }));
    
        setDaysTiming(prev => [...prev, ...newTimings]);
        setSelectedDays([]); // clear selections
        setTimings({
            full_day: 0,
            closed: 0,
            is_single_time: 0,
            is_slot_timing: 0,
            is_custom: 0,
            single_time: "",
            slot_start_time: "",
            slot_end_time: "",
            custom_value: "",
        });
    };
    const handleUpdateTimingSubmit = () => {
        if (selectedDays.length === 0) {
            toast.error("Please select at least one day.");
            return;
        }
    
        if (timings.is_slot_timing === 1 && (!timings.slot_start_time || !timings.slot_end_time)) {
            toast.error("Please select start and end time.");
            return;
        }
    
        if (timings.is_custom === 1 && timings.custom_value === "") {
            toast.error("Please fill the custom time field.");
            return;
        }
       const newTiming = {
        ...timings,
        day: selectedDays[0], // or whichever index you want
        };

        setDaysTiming(prev =>
            prev.map((item, i) =>
                i === isEditDays.editId ? { ...item, ...newTiming } : item
            )
        );


        setSelectedDays([]); // clear selections
        setTimings({
            full_day: 1,
            closed: 0,
            is_single_time: 0,
            is_slot_timing: 0,
            is_custom: 0,
            single_time: "",
            slot_start_time: "",
            slot_end_time: "",
            custom_value: "",
        });
        setIsEditDays({isEdit:false,editId:""});
    };
    
    const handleRemoveTiming = (index) => {
        if (daysTiming.length > 0) {
            setDaysTiming((prev) => prev.filter((_, i) => i !== index));
        }
    };

    const handleDayChange = (day) => {
        setSelectedDays((prev) => 
            prev.includes(day)
                ? prev.filter((d) => d !== day) // uncheck
                : [...prev, day]               // check
        );
    
        setTimings((prev) => ({
            ...prev,
            days: selectedDays.includes(day)
                ? prev.days?.filter((d) => d !== day)
                : [...(prev.days || []), day],
        }));
    };

    const [dateDurations, setDateDurations] = useState({
        name:"",
        colourType:"",
        type:"",
        start:"",
        end:"",
    });

    const [highlightedRanges, setHighlightedRanges] = useState([]);

    const addDurations = () => {
        if(dateDurations.start == "" || dateDurations.end == ""){
            toast.error("Please select start date and end date");
            return false;
        }
        if(dateDurations.name == ""){
            toast.error("Please enter duration title");
            return false;
        }
        if(dateDurations.type == ""){
            toast.error("Please select duration type checkbox");
            return false;
        }
        if (dateDurations.start && dateDurations.end && dateDurations.colourType) {
            setHighlightedRanges([]);
            setDateDurations({
                colour: "",
                type: "",
                start: "",
                end: "",
                name: "",
            });

            setHighlightedRanges([...highlightedRanges, { ...dateDurations }]);
        }
    };
    const updateDurations = () => {
        if(dateDurations.start == "" || dateDurations.end == ""){
            toast.error("Please select start date and end date");
            return false;
        }
        if(dateDurations.name == ""){
            toast.error("Please enter duration title");
            return false;
        }
        if(dateDurations.type == ""){
            toast.error("Please select duration type checkbox");
            return false;
        }
        if (dateDurations.start && dateDurations.end && dateDurations.colourType) {
            
            // setHighlightedRanges([...highlightedRanges, { ...dateDurations }]);
            setHighlightedRanges(prev =>
                prev.map((item, i) =>
                    i === isEditCal.editId ? { ...item, ...dateDurations } : item
                )
            );
            setDateDurations({
                colour: "",
                type: "",
                start: "",
                end: "",
                name: "",
            });
            setIsEditCal({isEdit:false,editId:''});
        }
    };

    const highlightRange = ({ date }) => {
        for (let range of highlightedRanges) {
          const startDate = new Date(range.start);
          const endDate = new Date(range.end);
            startDate.setHours(0, 0, 0, 0);
            endDate.setHours(23, 59, 59, 999); 
            if (date >= startDate && date <= endDate) {
                return `highlight-${range.colourType}`;
            }
        }
        return null;
    };

    const deleteDuration = (index) => {
        if (highlightedRanges.length > 0) {
            setHighlightedRanges((prev) => prev.filter((_, i) => i !== index));
        }
    };

    function formatTime(time) {
        if (!time) return "";
        const [hours, minutes] = time.split(":");
        let hour = parseInt(hours, 10);
        let period = hour >= 12 ? "PM" : "AM";
        hour = hour % 12 || 12; 
        return `${String(hour).padStart(2, "0")}:${minutes} ${period}`;
    }
    const handleSubmit = () => {

        if(!placeId){
            toast.error("Category field is required!");
            return false;
        }

        const formData = new FormData();
        formData.append(`placeId`,placeId);
        highlightedRanges.forEach((item, i) => {
            formData.append(`calendar[${i}][id]`,item?.id ?? '');
            formData.append(`calendar[${i}][place_id]`,placeId);
            formData.append(`calendar[${i}][type]`,'calendar');
            formData.append(`calendar[${i}][sub_type]`, item.type);
            formData.append(`calendar[${i}][custome_field]`, item.name);
            formData.append(`calendar[${i}][start_date]`, item.start);
            formData.append(`calendar[${i}][end_date]`, item.end);
        });

        // Only send seasonal timing if seasonal timing is enabled
        if (state.seasonalTiming === 1) {
            seasonalTiming.forEach((item, i) => {
                formData.append(`seasonal[${i}][id]`,item?.id ?? '');
                formData.append(`seasonal[${i}][place_id]`,placeId);
                formData.append(`seasonal[${i}][type]`,'seasonal');
                formData.append(`seasonal[${i}][start_time]`, item.start_time);
                formData.append(`seasonal[${i}][end_time]`, item.end_time);
                formData.append(`seasonal[${i}][start_date]`, item.start_date);
                formData.append(`seasonal[${i}][end_date]`, item.end_date);
            });
        }

        // Only send days timing if show timing is enabled
        if (state.showTiming === 1) {
            daysTiming.forEach((item, i) => {
                let sub_type = 
                item.full_day == 1 ? 'fullday' :
                item.closed == 1 ? 'closed' :
                item.is_custom == 1 ? 'custom' :
                item.is_single_time == 1 ? 'single_time' :
                item.is_slot_timing == 1 ? 'slot_timing' :
                '';        
                formData.append(`days[${i}][id]`,item?.id ?? '');
                formData.append(`days[${i}][place_id]`,placeId);
                formData.append(`days[${i}][type]`,'days');
                formData.append(`days[${i}][sub_type]`, sub_type);
                formData.append(`days[${i}][day]`, item.day);
                formData.append(`days[${i}][custome_field]`, item.custom_value || '');
                formData.append(`days[${i}][single_time]`, item.single_time || '');
                formData.append(`days[${i}][start_time]`, item.slot_start_time || '');
                formData.append(`days[${i}][end_time]`, item.slot_end_time || '');
            });
        }

        // Only send schedules if schedules is enabled
        if (state.schedules === 1) {
            schedules.forEach((item, i) => {
                formData.append(`schedules[${i}][id]`,item?.id ?? '');
                formData.append(`schedules[${i}][place_id]`,placeId);
                formData.append(`schedules[${i}][type]`,'schedules');
                formData.append(`schedules[${i}][custome_field]`, item.schedule);
            });
        }

        // Only send slots if per_day_slots is enabled
        if (state.per_day_slots === 1) {
            const validSlots = slots.filter((item) => {
                if (item?.type === 'period') {
                    return !!item?.sub_type;
                }
            
                if (item?.type === 'slots' || item?.type === 'vehicle_booking_period') {
                    return item?.slot_from && item?.slot_to;
                }
            
                return false;
            });
            
            validSlots.forEach((item, i) => {
                const customeField = item?.type === 'slots'
                    ? buildSlotCustomeField(item?.slot_from, item?.slot_to)
                    : (item?.custome_field ?? "");
                formData.append(`slots[${i}][id]`, item?.id ?? '');
                formData.append(`slots[${i}][place_id]`, placeId);
                formData.append(`slots[${i}][type]`, item?.type ?? 'slots');
                formData.append(`slots[${i}][sub_type]`, item?.sub_type ?? "");
                formData.append(`slots[${i}][parent_id]`, item?.parent_id ?? 0);
                formData.append(`slots[${i}][custome_field]`, customeField);
                formData.append(`slots[${i}][start_time]`, item?.slot_from ?? "");
                formData.append(`slots[${i}][end_time]`, item?.slot_to ?? "");
                formData.append(`slots[${i}][max_slot_bookings]`, item?.max_slot_bookings ?? "");
            });
        }



        axios.post(`/api/admin/v1/add-booking-timing`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${auth?.token}`,
            },
        }).then((res) => {
            // toast.success(res.data?.message);
            dispatch(getBookingTimingFormData(auth?.token,placeId));
        }).catch((err) => {
            toast.error(err.response.data?.message || "An error occurred");
            setErrors(err.response.data);
        });

        axios.post(`/api/admin/v1/add-update-ticket-booking-timings`, state, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${auth?.token}`,
            },
        }).then((res) => {
            toast.success(res.data?.message);
            dispatch(getBookingTimingFormData(auth?.token,placeId));
        }).catch((err) => {
            toast.error(err.response.data?.message || "An error occurred");
            setErrors(err.response.data);
        });
    };

    const handelTicketTypeChange = (value) => {
        dispatch(getTicketSubType(auth.token, value));
    };
    const handelTicketSubTypeChange = (value) => {
        dispatch(getTicketSubSubType(auth.token, value));
    };

    const defaultDayObject = (day) => ({
        day,
        id:"",
        closed: 0,
        full_day: 0,
        is_custom: 0,
        is_single_time: 0,
        is_slot_timing: 0,
        custom_value: "",
        single_time: "",
        slot_start_time: "",
        slot_end_time: "",
    });

    useEffect(() => {
    const days = bookingTimings?.filter((item => item?.type == 'days'));
    const seasonal = bookingTimings.filter((item => item?.type == 'seasonal'));
    const calendar = bookingTimings.filter((item => item?.type == 'calendar'));
    const schedules = bookingTimings.filter((item => item?.type == 'schedules'));
    const slotsData = bookingTimings.filter((item => item?.type == 'slots'));
    const vehicleSlotsData = bookingTimings.filter((item => item?.type == 'vehicle_booking_period'));
    const parentperiod = bookingTimings.filter((item => item?.type == 'period'));
    setParentSlots(parentperiod.map(item => ({
        id:item.id,
        sub_type:item.sub_type,
    })));
    console.log('parentperiod -->>',parentperiod);
    console.log('parentSlots -->>',parentSlots);
    const weekDays = days.map((item => item?.day));
    const mappedDays = weekDays.map((dayName) => {
        const dayData = days.find((d) => d.day === dayName);
        const base = defaultDayObject(dayName);
        base.id = dayData.id;
        if (dayData) {
            switch (dayData.sub_type) {
            case "closed":
                base.closed = 1;
                break;
            case "fullday":
                base.full_day = 1;
                break;
            case "custom":
                base.is_custom = 1;
                base.custom_value = dayData.custome_field || "";
                break;
            case "slot_timing":
                base.is_slot_timing = 1;
                base.slot_start_time = dayData.start_time || "";
                base.slot_end_time = dayData.end_time || "";
                break;
            case "single_time":
                base.is_single_time = 1;
                base.single_time = dayData.single_time || "";
                break;
            default:
            break;
        }
      }

      return base;
    });

    setDaysTiming(mappedDays);
    // set seasonal api data into seasonal
    const seasonalData = seasonal.map(item => ({
        id:item.id,
        is_seasonal: 1,
        start_time: item.start_time || '',
        end_time: item.end_time || '',
        start_date: item.start_date || '',
        end_date: item.end_date || '',
    }));
    if(seasonalData.length > 0){
        setSeasonalTiming(seasonalData);
    }else{
        setSeasonalTiming([{ is_seasonal:0,start_time: '',end_time: '',start_date:'',end_date:''}]);
    }
    
    // set schedules api data into schedules
    const scheduleData = schedules.map(item => ({
        id:item.id,
        is_schedule: 1,
        schedule: item?.custome_field,
    }));
    if(scheduleData.length > 0){
        setSchedules(scheduleData);
    }else{
        setSchedules([{is_schedule:0,schedule:''}]);
    }
    // set schedules api data into schedules
    const dataSlot = slotsData.map(item => ({
        id:item.id,
        is_slot: 1,
        parent_id: item?.parent_id ?? 0,
        custome_field: item?.custome_field ?? "",
        type: "slots",
        sub_type: item?.sub_type ?? "",
        slot_from: item?.start_time,
        slot_to: item?.end_time,
        max_slot_bookings: item?.max_slot_bookings ?? "",
    }));
    const dataVehicleBookingPeriod = vehicleSlotsData.map(item => ({
        id:item.id,
        is_slot: 1,
        parent_id: item?.parent_id ?? 0,
        custome_field: item?.custome_field ?? "",
        type: "vehicle_booking_period",
        sub_type: item?.sub_type ?? "",
        slot_from: item?.start_time,
        slot_to: item?.end_time,
        max_slot_bookings: item?.max_slot_bookings ?? "",
    }));
    const dataPeriod = parentperiod.map(item => ({
        id:item.id,
        is_slot: 1,
        parent_id: item?.parent_id ?? 0,
        custome_field: item?.custome_field ?? "",
        type: "period",
        sub_type: item?.sub_type ?? "",
        slot_from: item?.start_time,
        slot_to: item?.end_time,
        max_slot_bookings: item?.max_slot_bookings ?? "",
    }));
    if(dataPeriod.length > 0 || dataSlot.length > 0 || dataVehicleBookingPeriod.length > 0){
        setSlots([
            ...dataPeriod,
            ...dataSlot,
            ...dataVehicleBookingPeriod,
            { is_slot:0, parent_id:0, custome_field:"", type:"period", sub_type:"", slot_from:"", slot_to:"", max_slot_bookings:"" },
            { is_slot:0, parent_id:0, custome_field:"", type:"slots", sub_type:"", slot_from:"", slot_to:"", max_slot_bookings:"" },
            { is_slot:0, parent_id:0, custome_field:"", type:"vehicle_booking_period", sub_type:"", slot_from:"", slot_to:"", max_slot_bookings:"" }
        ]);
    }else{
        setSlots([
            { is_slot:0, parent_id:0, custome_field:"", type:"period", sub_type:"", slot_from:"", slot_to:"", max_slot_bookings:"" },
            { is_slot:0, parent_id:0, custome_field:"", type:"slots", sub_type:"", slot_from:"", slot_to:"", max_slot_bookings:"" },
            { is_slot:0, parent_id:0, custome_field:"", type:"vehicle_booking_period", sub_type:"", slot_from:"", slot_to:"", max_slot_bookings:"" }
        ]);
    }
    // set calender api data into calender
    const calenderData = calendar.map(item => ({
            id: item?.id,
            colourType: item?.sub_type,
            type:item?.sub_type,
            start:item?.start_date,
            end:item?.end_date,
            name:item?.custome_field,
        }));
    if(calenderData.length > 0){
        setHighlightedRanges(calenderData);
    }else{
        setHighlightedRanges([]);
    }
    },[bookingTimings]);
    const handleDel = (type,ids) => {
        if (window.confirm("Are You Sure You Want To Delete !")) {
            let delIds = [];
            if(type == "days"){
                delIds = daysTiming.filter(item => item?.id).map(item => item.id);
                if(delIds.length > 0){
                    dispatch(deleteTimings(auth?.token,delIds,placeId));
                }else{
                    setDaysTiming([]);
                }
            }else if (type == 'calender'){
                delIds = highlightedRanges.filter(item => item?.id).map(item => item.id);
                if(delIds.length > 0){
                    dispatch(deleteTimings(auth?.token,delIds,placeId));
                }else{
                    setDateDurations({colour: "",type: "",start: "",end: "",name: ""});
                    setHighlightedRanges([]);
                }  
            }else{
                dispatch(deleteTimings(auth?.token,ids,placeId));  

            }
            // getBookingTimingFormData(auth?.token,placeId);
        }

    };
    const [isEditDays,setIsEditDays] = useState({
        isEdit:false,
        editId:""
    });
    const editDays = (day) =>{
        setSelectedDays([day?.day]);
        setTimings({
            day:day?.day,
            id:day?.id ?? '',
            full_day:day?.full_day,
            closed:day?.closed,
            is_single_time:day?.is_single_time,
            is_slot_timing:day?.is_slot_timing,
            is_custom:day?.is_custom,
            single_time:day?.single_time,
            slot_start_time:day?.slot_start_time,
            slot_end_time:day?.slot_end_time,
            custom_value:day?.custom_value
        });
    }
    const [isEditCal,setIsEditCal] = useState({
        isEdit:false,
        editId:""
    });
    const editCalender = (cal) =>{
        setDateDurations({
            id:cal?.id ?? '',
            name:cal?.name,
            colourType:cal?.colourType,
            type:cal?.type,
            start:cal?.start,
            end:cal?.end,
        });
    }

    return (
        <div className="container bg-white p-4 rounded shadow-lg">
            <Row>
                <Col md={12}>
                    <Label className="d-flex align-items-center">
                        <h4 className="mb-4 text-right text-black">Timing</h4>
                    </Label>
                </Col>
            </Row>
            <Row>
                <Col md={4}>
                    <FormGroup>
                        <Label className="d-flex align-items-center">
                            <Input type="checkbox" 
                            checked={state.is_ticket_type == 1}
                            onChange={(e) => {
                                setState(prev => ({
                                    ...prev,
                                    is_ticket_type: e.target.checked ? 1 : 0
                                }));
                            }}
                            className="me-2" />
                            Ticket Type
                        </Label>
                    </FormGroup>
                    {state.is_ticket_type === 1 && (
                        <>
                        <div className="mb-3">
                            <Input type="select" name="place_id" 
                            value={state.ticket_type} 
                            onChange={(e)=> {
                                    setState((prev)=>({
                                        ...prev,
                                        ticket_type: e.target.value,
                                    }));
                                    handelTicketTypeChange(e.target.value);
                                }
                            }
                            >
                            <option value="">Select Ticket Type</option>
                            {TicketTypeList?.map((item) => (
                                <option key={item.id} value={item.id}>{item.ticket_type}</option>
                            ))}
                            </Input>
                        </div>
                        {/* {additionalFieldInput?.map((field, i) => (
                            <div className="d-flex align-items-center mb-3" key={i}>
                                <Input type="text" 
                                placeholder="Field Name" 
                                value={field.name} 
                                onChange={(e) => handleAdditionalInputChange(i, "name", e.target.value,'groupBooking')} 
                                className="me-2" />
                                <Button className="ms-1" color="primary" onClick={addAdditionalFieldInput}>
                                    +
                                </Button>
                                <Button className="ms-1" color="danger" onClick={()=> removeAdditionalFieldInput(i)}>
                                -
                                </Button>
                            </div>
                        ))}
                        <Button className="bg-success text-white" size="sm" onClick={handleAdditionalSubmit}>
                            Add Booking Category
                        </Button> */}
                        </>
                    )}
                </Col>
                <Col md={4}>
                    <FormGroup>
                        <Label className="d-flex align-items-center">
                            <Input type="checkbox" 
                            checked={state.is_ticket_sub_type == 1}  
                            onChange={(e) => {
                                setState(prev => ({
                                    ...prev,
                                    is_ticket_sub_type: e.target.checked ? 1 : 0
                                }));
                            }}
                            className="me-2" />
                            Ticket Sub Type
                        </Label>
                    </FormGroup>
                    {state.is_ticket_sub_type === 1 && state.is_ticket_type === 1 && (
                        <>
                        <div className="mb-3">
                            <Input type="select" name="place_id" 
                            value={state.ticket_sub_type} 
                            onChange={(e)=> {
                                setState((prev)=>({
                                    ...prev,
                                    ticket_sub_type: e.target.value,
                                }));
                                handelTicketSubTypeChange(e.target.value);
                            }
                            }
                            >
                            <option value="">Select Sub ticket Type</option>
                            {TicketSubTypeList?.map((item) => (
                                <option key={item.id} value={item.id}>{item.sub_type}</option>
                            ))}
                            </Input>
                        </div>
                        {/* {subAdditionalInput?.map((field, i) => (
                            <div className="d-flex align-items-center mb-3" key={i}>
                                <Input type="text" 
                                placeholder="Field Name" 
                                value={field.name} 
                                onChange={(e) => handleSubAdditionalInputChange(i, "name", e.target.value,'groupBooking')} 
                                className="me-2" />
                                <Button className="ms-1" color="primary" onClick={addSubAdditionalFieldInput}>
                                    +
                                </Button>
                                <Button className="ms-1" color="danger" onClick={()=> removeSubAdditionalFieldInput(i)}>
                                -
                                </Button>
                            </div>
                        ))}
                        <Button className="bg-success text-white" size="sm" onClick={handleSubAdditionalSubmit}>
                            Add Booking Sub Category
                        </Button> */}
                        </>
                    )}
                </Col>
                <Col md={4}>
                    <FormGroup>
                        <Label className="d-flex align-items-center">
                            <Input type="checkbox" 
                            checked={state.is_ticket_sub_sub_type == 1} 
                            onChange={(e) => {
                                setState(prev => ({
                                    ...prev,
                                    is_ticket_sub_sub_type: e.target.checked ? 1 : 0
                                }));
                            }} 
                            className="me-2" />
                            Ticket Sub Sub Type
                        </Label>
                    </FormGroup>
                    {state.is_ticket_sub_sub_type === 1 && state.is_ticket_sub_type === 1 && state.is_ticket_type === 1 && (
                        <>
                        <div className="mb-3">
                            <Input type="select" name="place_id" 
                            value={state.ticket_sub_sub_type} 
                            onChange={(e)=>
                                setState((prev)=>({
                                    ...prev,
                                    ticket_sub_sub_type: e.target.value,
                                }))
                            }
                            >
                            <option value="">Select Sub Sub Field Type</option>
                            {TicketSubSubTypeList?.map((item) => (
                                <option key={item.id} value={item.id}>{item.sub_sub_type}</option>
                            ))}
                            </Input>
                        </div>
                        {/* {subSubAdditionalInput?.map((field, i) => (
                            <div className="d-flex align-items-center mb-3" key={i}>
                                <Input type="text" 
                                placeholder="Field Name" 
                                value={field.name} 
                                onChange={(e) => handleSubSubAdditionalInputChange(i, "name", e.target.value,'groupBooking')} 
                                className="me-2" />
                                <Button className="ms-1" color="primary" onClick={addSubSubAdditionalFieldInput}>
                                    +
                                </Button>
                                <Button className="ms-1" color="danger" onClick={()=> removeSubSubAdditionalFieldInput(i)}>
                                -
                                </Button>
                            </div>
                        ))}
                        <Button className="bg-success text-white" size="sm" onClick={handleSubSubAdditionalSubmit}>
                            Add Booking Sub Sub Category
                        </Button> */}
                        </>
                    )}
                </Col>
                <Col md={6} className="mt-4">
                    <Row>
                        <Col md={12} className="">
                            <h6 className="text-black">Select days and Time</h6>
                        </Col>
                        <Col md={12} className="">
                            <FormGroup>
                                <Label className="d-flex align-items-center">
                                    <Input type="checkbox" 
                                    checked={state.showTiming === 1}
                                    onChange={(e) => {
                                        setState(prev => ({
                                            ...prev,
                                            showTiming: e.target.checked ? 1 : 0,
                                            seasonalTiming:0,
                                            per_day_slots:0,
                                            schedules:0
                                        }));
                                    }}
                                    className="me-2" />
                                    Show Timing
                                </Label>
                            </FormGroup>
                        </Col>
                        {state.showTiming === 1 && (
                            <>
                            <Col md={12}>
                                <div className="checkbox-container">
                                    {options.map(({ day, label }) => (
                                        <div key={day} className="checkbox-wrapper">
                                            <input
                                            type="checkbox"
                                            id={`checkbox-${day}`}
                                            className="days"
                                            checked={selectedDays.includes(day)}
                                            onChange={() => handleDayChange(day)}
                                            />
                                            <label htmlFor={`checkbox-${day}`}>{label}</label>
                                        </div>
                                    ))}
                                </div>
                            </Col>
                            <Col md={12}>
                                <FormGroup  className="d-flex align-items-center">
                                    <Label className="d-flex align-items-center m-1">
                                        <Input type="checkbox" 
                                        checked={timings.full_day === 1}
                                        onChange={(e) => {
                                            setTimings(prev => ({
                                                ...prev,
                                                full_day: e.target.checked ? 1 : 0,
                                                closed: 0,
                                                is_single_time: 0,
                                                is_slot_timing: 0,
                                                is_custom: 0
                                            }));
                                        }}
                                        className="m-1" />
                                        Open 24 hours
                                    </Label>
                                    <Label className="d-flex align-items-center m-1">
                                        <Input type="checkbox" 
                                        checked={timings.closed === 1}
                                        onChange={(e) => {
                                            setTimings(prev => ({
                                                ...prev,
                                                closed: e.target.checked ? 1 : 0,
                                                full_day: 0,
                                                is_single_time: 0,
                                                is_slot_timing: 0,
                                                is_custom: 0
                                            }));
                                        }}
                                        className="m-1" />
                                        Closed
                                    </Label>
                                    <Label className="d-flex align-items-center m-1">
                                        <Input type="checkbox" 
                                        checked={timings.is_single_time === 1}
                                        onChange={(e) => {
                                            setTimings(prev => ({
                                                ...prev,
                                                is_single_time: e.target.checked ? 1 : 0,
                                                closed: 0,
                                                full_day: 0,
                                                is_slot_timing: 0,
                                                is_custom: 0
                                            }));
                                        }}
                                        className="m-1" />
                                        Single Time
                                    </Label>
                                    <Label className="d-flex align-items-center m-1">
                                        <Input type="checkbox" 
                                        checked={timings.is_slot_timing=== 1}
                                        onChange={(e) => {
                                            setTimings(prev => ({
                                                ...prev,
                                                is_slot_timing: e.target.checked ? 1 : 0,
                                                closed: 0,
                                                is_single_time: 0,
                                                full_day: 0,
                                                is_custom: 0
                                            }));
                                        }}
                                        className="m-1" />
                                        Slot Timing
                                    </Label>
                                    <Label className="d-flex align-items-center m-1">
                                        <Input type="checkbox" 
                                        checked={timings.is_custom === 1}
                                        onChange={(e) => {
                                            setTimings(prev => ({
                                                ...prev,
                                                is_custom: e.target.checked ? 1 : 0,
                                                is_slot_timing:0,
                                                closed: 0,
                                                is_single_time: 0,
                                                full_day: 0,
                                            }));
                                        }}
                                        className="m-1" />
                                        Custom
                                    </Label>
                                </FormGroup>
                            </Col>
                            <Col md={12}>
                                <div  className="d-flex align-items-center">
                                    {timings.is_single_time === 1 && (
                                        <fieldset className="m-2">
                                            <Label className="text-black">Time</Label>
                                            <Input type="time" value={timings.single_time} 
                                            onChange={(e) => {
                                                setTimings(prev => ({
                                                    ...prev,
                                                    single_time: e.target.value
                                                }));
                                            }} 
                                            className="m-1" />
                                        </fieldset>
                                    )}
                                    {timings.is_custom === 1 && (
                                        <fieldset className="m-2">
                                            <Label className="text-black">Custome Time</Label>
                                            <Input type="text" value={timings.custom_value} 
                                            onChange={(e) => {
                                                setTimings(prev => ({
                                                    ...prev,
                                                    custom_value: e.target.value
                                                }));
                                            }} 
                                            className="m-1" />
                                        </fieldset>
                                    )}
                                    {timings.is_slot_timing === 1 && (
                                    <>
                                        <fieldset className="m-2">
                                            <Label className="text-black">Start Time</Label>
                                            <Input type="time" value={timings.slot_start_time}  
                                            onChange={(e) => {
                                                setTimings(prev => ({
                                                    ...prev,
                                                    slot_start_time: e.target.value
                                                }));
                                            }} 
                                            className="m-1" />
                                        </fieldset>
                                        <fieldset className="m-2">
                                            <Label className="text-black">End Time</Label>
                                            <Input type="time" value={timings.slot_end_time} 
                                            onChange={(e) => {
                                                setTimings(prev => ({
                                                    ...prev,
                                                    slot_end_time: e.target.value
                                                }));
                                            }} 
                                            className="m-1" />
                                        </fieldset>
                                    </>
                                    )}
                                </div>
                            </Col>
                            <Col md={12}>
                                <div  className="d-flex align-items-center">
                                    {isEditDays.isEdit ? (
                                        <Button className="bg-success text-white m-2" size="sm" disabled={daysTiming.length === 7} onClick={handleUpdateTimingSubmit}>
                                            Edit Timing
                                        </Button>
                                    ):(
                                        <Button className="bg-success text-white m-2" size="sm" onClick={handleAddTimingSubmit}>
                                            Add Timing
                                        </Button>
                                    )}
                                    <Button className="bg-danger text-white m-2" size="sm" disabled={daysTiming.length === 0} onClick={() =>handleDel('days')}>
                                        Clear All Timing
                                    </Button>
                                </div>
                            </Col>
                        </>
                        )}
                    </Row>
                </Col>
                <Col md={6} className="mt-5">
                    {state.showTiming === 1 && (
                        <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Day</th>
                                    <th scope="col">Time</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {daysTiming
                                    ?.sort((a, b) => {
                                        // Define day order for sorting
                                        const dayOrder = {
                                            'Sunday': 0,
                                            'Monday': 1,
                                            'Tuesday': 2,
                                            'Wednesday': 3,
                                            'Thusday': 4,
                                            'Friday': 5,
                                            'Saturday': 6
                                        };
                                        
                                        // First sort by day order
                                        const dayComparison = dayOrder[a.day] - dayOrder[b.day];
                                        if (dayComparison !== 0) {
                                            return dayComparison;
                                        }
                                        
                                        // If same day, sort by start time
                                        if (a.slot_start_time && b.slot_start_time) {
                                            return a.slot_start_time.localeCompare(b.slot_start_time);
                                        }
                                        
                                        return 0;
                                    })
                                    ?.map((t,i)=> (
                                    <tr key={i}>
                                        <th scope="row">{i+1}</th>
                                        <td>{t.day}</td>
                                        <td>
                                            {
                                            t.full_day === 1
                                            ? "Open All Day"
                                            : t.closed === 1
                                            ? "Closed"
                                            : t.is_single_time === 1
                                            ? formatTime(t?.single_time)
                                            : t.is_slot_timing === 1
                                            ? formatTime(t?.slot_start_time)+ ' - ' + formatTime(t?.slot_end_time)
                                            : t.is_custom === 1 
                                            ? t.custom_value
                                            :""}
                                        </td>
                                        <td>
                                            <AiOutlineEdit
                                            size={22}
                                            className="text-warning me-3"
                                            onClick={() => {
                                                editDays(t);
                                                setIsEditDays((prev) => ({
                                                    ...prev,
                                                    isEdit:true,
                                                    editId:daysTiming.indexOf(t)
                                                }));
                                            }}
                                            />
                                            {t?.id ? (
                                                <AiOutlineDelete
                                                    size={22}
                                                    className="text-danger"
                                                    onClick={() => {
                                                        handleDel('single',[t.id]);
                                                    }}
                                                />
                                            ):(
                                                <AiOutlineDelete
                                                    size={22}
                                                    className="text-danger"
                                                    onClick={()=>handleRemoveTiming(daysTiming.indexOf(t))}
                                                />
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </Col>
                <Col md={12}>
                    <FormGroup>
                        <Label className="d-flex align-items-center">
                            <Input type="checkbox" 
                            checked={state.seasonalTiming === 1}
                            onChange={(e) => {
                                setState(prev => ({
                                    ...prev,
                                    seasonalTiming: e.target.checked ? 1 : 0,
                                    showTiming:0,
                                    per_day_slots:0,
                                    schedules:0
                                }));
                            }}
                            className="me-2" />
                            Seasonal Timing
                        </Label>
                    </FormGroup>
                    {state.seasonalTiming === 1 && (
                        <>
                        {seasonalTiming?.map((s, i) => (
                            <div  className="d-flex align-items-center">
                                <fieldset className="m-2">
                                    <Label className="text-black">Start Time</Label>
                                    <Input type="time" value={s.start_time} 
                                    onChange={(e) => handleSeasonalTiming(i, "start_time", e.target.value)} 
                                    className="m-1" />
                                </fieldset>
                                <fieldset className="m-2">
                                    <Label className="text-black">End Time</Label>
                                    <Input type="time" value={s.end_time} 
                                    onChange={(e) => handleSeasonalTiming(i, "end_time", e.target.value)} 
                                    className="m-1" />
                                </fieldset>
                                <fieldset className="m-2">
                                    <Label className="text-black">Start Time</Label>
                                    <Input type="date" value={s.start_date} 
                                    onChange={(e) => handleSeasonalTiming(i, "start_date", e.target.value)} 
                                    className="m-1" />
                                </fieldset>
                                <fieldset className="m-2">
                                    <Label className="text-black">End Time</Label>
                                    <Input type="date" value={s.end_date} 
                                    onChange={(e) => handleSeasonalTiming(i, "end_date", e.target.value)} 
                                    className="m-1" />
                                </fieldset>
                                <Button className="ms-1 mt-4" color="primary" onClick={addSeasonalTiming}>
                                    +
                                </Button>
                                {s.id ? (
                                <Button className="ms-1 mt-4" color="danger" onClick={() => handleDel('seasonal',[s.id])}>
                                -
                                </Button>
                                ):(
                                <Button className="ms-1 mt-4" color="danger" onClick={()=> removeSeasonalTiming(i)}>
                                -
                                </Button>
                                )}
                            </div>
                        ))}
                        </>
                    )}
                </Col>
                <Col md={12}>
                    <FormGroup>
                        <Label className="d-flex align-items-center">
                            <Input type="checkbox" 
                            checked={state.schedules === 1}
                            onChange={(e) => {
                                setState(prev => ({
                                    ...prev,
                                    schedules: e.target.checked ? 1 : 0,
                                    seasonalTiming: 0,
                                    showTiming:0,
                                    per_day_slots:0,
                                }));
                            }}
                            className="me-2" />
                            Schedules
                        </Label>
                    </FormGroup>
                    {state.schedules === 1 && (
                        <>
                        {schedules?.map((d, i) => (
                            <div  className="d-flex align-items-center">
                                <fieldset className="m-2">
                                    <Label className="text-black">Add Field</Label>
                                    <Input type="text" value={d.schedule} 
                                    onChange={(e) => handleSchedule(i, "schedule", e.target.value)} 
                                    className="m-1" />
                                </fieldset>
                                <Button className="ms-1 mt-4" color="primary" onClick={addScheduleTiming}>
                                    +
                                </Button>
                                {d.id ? (
                                    <Button className="ms-1 mt-4" color="danger" onClick={() => handleDel('schedules',[d.id])}>
                                    -
                                    </Button>
                                ):(
                                    <Button className="ms-1 mt-4" color="danger" onClick={()=> removeScheduleTiming(i)}>
                                    -
                                    </Button>
                                )}
                            </div>
                        ))}
                        </>
                    )}
                </Col>
                <Col md={12}>
                    <FormGroup>
                        <Label className="d-flex align-items-center">
                            <Input type="checkbox" 
                            checked={state.per_day_slots === 1}
                            onChange={(e) => {
                                setState(prev => ({
                                    ...prev,
                                    per_day_slots: e.target.checked ? 1 : 0,
                                    seasonalTiming: 0,
                                    showTiming:0,
                                    schedules:0
                                }));
                            }}
                            className="me-2" />
                            Slots
                        </Label>
                    </FormGroup>
                    {state.per_day_slots === 1 && (
                        <>
                        {slots?.map((d, i) => d.type === 'period' ? (
                            <div  className="d-flex align-items-center">
                                <fieldset className="m-2">
                                    <Label className="text-black">Slot Name (Morning, Afternoon, Evening)</Label>
                                    <Input type="text" value={d.sub_type} 
                                    onChange={(e) => handleSlots(i, "sub_type", e.target.value)} 
                                    className="m-1" />
                                </fieldset>
                                <fieldset className="m-2">
                                    <Label className="text-black">Max Slot Booking Seats</Label>
                                    <Input type="number" value={d.max_slot_bookings}
                                    onChange={(e) => handleSlots(i, "max_slot_bookings", e.target.value)}
                                    className="m-1" />
                                </fieldset>
                                <Button className="ms-1 mt-4" color="primary" onClick={() => addSlotsTiming('period')}>
                                    +
                                </Button>
                                {d.id ? (
                                    <Button className="ms-1 mt-4" color="danger" onClick={() => handleDel('period',[d.id])}>
                                    -
                                    </Button>
                                ):(
                                    <Button className="ms-1 mt-4" color="danger" onClick={()=> removeSlotsTiming(i,'period')}>
                                    -
                                    </Button>
                                )}
                            </div>
                        ) : null)}
                        {slots?.map((d, i) => d.type === 'slots' ? (
                            <div  className="d-flex align-items-center">
                                <fieldset className="m-2">
                                    <Label className="text-black">Parent Slot</Label>
                                    <select
                                        className="form-select"
                                        value={d.parent_id || ""}
                                        onChange={(e) => handleSlots(i, "parent_id", e.target.value)}
                                    >
                                        <option value="">Select Parent Slot</option>
                                        {parentSlots.map((s) => (
                                                <option key={s.id} value={s.id}>{s.sub_type}</option>
                                            ))}
                                    </select>
                                </fieldset>
                                <fieldset className="m-2">
                                    <Label className="text-black">From</Label>
                                    <Input type="time" value={d.slot_from} 
                                    onChange={(e) => handleSlots(i, "slot_from", e.target.value)} 
                                    className="m-1" />
                                </fieldset>
                                <fieldset className="m-2">
                                    <Label className="text-black">To</Label>
                                    <Input type="time" value={d.slot_to} 
                                    onChange={(e) => handleSlots(i, "slot_to", e.target.value)} 
                                    className="m-1" />
                                </fieldset>
                                <fieldset className="m-2">
                                    <Label className="text-black">Max Slot Booking Seats</Label>
                                    <Input type="number" value={d.max_slot_bookings}
                                    onChange={(e) => handleSlots(i, "max_slot_bookings", e.target.value)}
                                    className="m-1" />
                                </fieldset>
                                <Button className="ms-1 mt-4" color="primary" onClick={() => addSlotsTiming('slots')}>
                                    +
                                </Button>
                                {d.id ? (
                                    <Button className="ms-1 mt-4" color="danger" onClick={() => handleDel('slots',[d.id])}>
                                    -
                                    </Button>
                                ):(
                                    <Button className="ms-1 mt-4" color="danger" onClick={()=> removeSlotsTiming(i,'slots')}>
                                    -
                                    </Button>
                                )}
                            </div>
                        ) : null)}
                        <div className="mt-3 pt-2 border-top">
                            <FormGroup className="mb-1">
                                <Label className="text-black fw-bold">Vehicle Timing</Label>
                            </FormGroup>
                            {slots?.map((d, i) => d.type === 'vehicle_booking_period' ? (
                                <div  className="d-flex align-items-center">
                                    <fieldset className="m-2">
                                        <Label className="text-black">From</Label>
                                        <Input type="time" value={d.slot_from}
                                        onChange={(e) => handleSlots(i, "slot_from", e.target.value)}
                                        className="m-1" />
                                    </fieldset>
                                    <fieldset className="m-2">
                                        <Label className="text-black">To</Label>
                                        <Input type="time" value={d.slot_to}
                                        onChange={(e) => handleSlots(i, "slot_to", e.target.value)}
                                        className="m-1" />
                                    </fieldset>
                                    <fieldset className="m-2">
                                        <Label className="text-black">Max Slot Booking Seats</Label>
                                        <Input type="number" value={d.max_slot_bookings}
                                        onChange={(e) => handleSlots(i, "max_slot_bookings", e.target.value)}
                                        className="m-1" />
                                    </fieldset>
                                    <Button className="ms-1 mt-4" color="primary" onClick={() => addSlotsTiming('vehicle_booking_period')}>
                                        +
                                    </Button>
                                    {d.id ? (
                                        <Button className="ms-1 mt-4" color="danger" onClick={() => handleDel('vehicle_booking_period',[d.id])}>
                                        -
                                        </Button>
                                    ):(
                                        <Button className="ms-1 mt-4" color="danger" onClick={()=> removeSlotsTiming(i,'vehicle_booking_period')}>
                                        -
                                        </Button>
                                    )}
                                </div>
                            ) : null)}
                        </div>
                        </>
                    )}
                </Col>
                <Col md={12} className="mt-2">
                    <Label className="d-flex align-items-center">
                        <div className="form-check form-switch">
                            <input className="form-check-input" type="checkbox" 
                            checked={state.showCalendar} 
                            onChange={(e) => setState({...state,showCalendar:e.target.checked ? 1 :0})} 
                            />
                        </div>
                        <h4 className="text-right text-black">Calendar</h4>
                    </Label>
                </Col>
                {state.showCalendar === 1 ? (
                    <>
                    <Col md={4}>
                        <Calendar 
                            onChange={() => {}} 
                            tileClassName={highlightRange} 
                        />
                    </Col>
                    <Col md={8}>
                        <FormGroup>
                            <Label className="d-flex align-items-center">
                                Duration
                            </Label>
                        </FormGroup>
                        <Row>
                            <Col md={12}>
                                <div  className="d-flex align-items-center">
                                    <fieldset className="m-2">
                                        <Label className="text-black">Start Date</Label>
                                        <Input type="date" 
                                        value={dateDurations.start} 
                                        onChange={(e) => setDateDurations((pre) => ({...pre,
                                            start: e.target.value
                                        }))} 
                                        className="m-1" />
                                    </fieldset>
                                    <fieldset className="m-2">
                                        <Label className="text-black">End Date</Label>
                                        <Input type="date" 
                                        value={dateDurations.end} 
                                        onChange={(e) => setDateDurations((pre) => ({...pre,
                                            end: e.target.value
                                        }))} 
                                        className="m-1" />
                                    </fieldset>
                                    <fieldset className="m-2">
                                    <Label className="text-black">Duration Title</Label>
                                        <Input type="text" 
                                        placeholder="Enter Duration Title"
                                        value={dateDurations.name} 
                                        onChange={(e) => setDateDurations((pre) => ({...pre,
                                            name: e.target.value
                                        }))} 
                                        className="m-1" />
                                    </fieldset>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <FormGroup  className="d-flex align-items-center">
                                    <Label className="d-flex align-items-center m-1">
                                        <Input type="checkbox" 
                                        checked={dateDurations.type === 'closed'}
                                        onChange={(e) => setDateDurations((pre) => ({...pre,
                                            type: e.target.checked ? 'closed' : 0,
                                            colourType: "closed"
                                        }))} 
                                        className="m-1" />
                                        Closed
                                    </Label>
                                    <Label className="d-flex align-items-center m-1">
                                        <Input type="checkbox" 
                                        checked={dateDurations.type === 'holiday'}
                                        onChange={(e) => setDateDurations((pre) => ({...pre,
                                            type: e.target.checked ? 'holiday' : 0,
                                            colourType: "holiday"
                                        }))} 
                                        className="m-1" />
                                        Holiday
                                    </Label>
                                    <Label className="d-flex align-items-center m-1">
                                        <Input type="checkbox" 
                                        checked={dateDurations.type === 'free'}
                                        onChange={(e) => setDateDurations((pre) => ({...pre,
                                            type:e.target.checked ? 'free' : 0,
                                            colourType: "free"
                                        }))} 
                                        className="m-1" />
                                        Free Ticket
                                    </Label>
                                </FormGroup>
                            </Col>
                            <Col md={12}>
                                <div  className="d-flex align-items-center mb-3">
                                    {isEditCal.isEdit ? (
                                        <Button className="m-1" color="primary" onClick={updateDurations}>
                                           Edit Duration
                                        </Button>
                                    ):(
                                        <Button className="m-1" color="primary" onClick={addDurations}>
                                            Add Duration
                                        </Button>
                                    )}
                                    <Button className="m-1" color="danger"
                                    disabled={highlightedRanges.length === 0} 
                                    onClick={()=> handleDel('calender')}
                                    >
                                    Clear All
                                    </Button>
                                </div>
                            </Col>
                            <Col md={12}>
                            {highlightedRanges.length > 0 && (
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Duration Title</th>
                                            <th scope="col">From</th>
                                            <th scope="col">To</th>
                                            <th scope="col">Type</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {highlightedRanges?.map((r,i)=> (
                                            <tr className={`highlight-${r.colourType}`}>
                                                <th scope="row" key={i}>{i+1}</th>
                                                <td>{r.name}</td>
                                                <td>{r.start}</td>
                                                <td>{r.end}</td>
                                                <td>{r.type}</td>
                                                <td>
                                                    {/* <Button className="" color="danger" onClick={()=>deleteDuration(i)}>
                                                        Delete
                                                    </Button> */}
                                                     <AiOutlineEdit
                                                        size={22}
                                                        className="text-warning me-3"
                                                         onClick={() => {
                                                            editCalender(r);
                                                            setIsEditCal((prev) => ({
                                                                ...prev,
                                                                isEdit:true,
                                                                editId:i
                                                            }));
                                                        }}
                                                        />
                                                        {r?.id ? (
                                                            <AiOutlineDelete
                                                                size={22}
                                                                className="text-danger"
                                                                onClick={() => handleDel('single',[r.id])}
                                                            />
                                                        ):(
                                                            <AiOutlineDelete
                                                                size={22}
                                                                className="text-danger"
                                                                onClick={() => deleteDuration(i)}
                                                            />
                                                        )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                            </Col>
                        </Row>
                    </Col>
                    </>
                ):null}
            </Row>
            <Col md={12} className="mt-2">
                <Label className="d-flex align-items-center">
                    <div className="form-check form-switch">
                        <input className="form-check-input" type="checkbox" 
                        checked={state.showTicketTiming} 
                        onChange={(e) => setState({...state,showTicketTiming:e.target.checked ? 1:0})} 
                        />
                    </div>
                    <h4 className="text-right text-black">Ticket Booking Time</h4>
                </Label>
            </Col>
            {state.showTicketTiming && (
                <>
                   <Col md={12}>
                        <Row>
                            <Col md={12}>
                                <FormGroup  className="d-flex align-items-center">
                                    <Label className="d-flex align-items-center m-1">
                                        <Input type="checkbox" 
                                        checked={state.is_full_day === 1}
                                        onChange={(e) => setState((pre) => ({...pre,
                                            is_full_day: e.target.checked ? 1 : 0,
                                            is_till_time:0
                                        }))} 
                                        className="m-1" />
                                        Full Day
                                    </Label>
                                    <Label className="d-flex align-items-center m-1">
                                        <Input type="checkbox" 
                                        checked={state.is_till_time === 1}
                                        onChange={(e) => setState((pre) => ({...pre,
                                            is_till_time: e.target.checked ? 1 : 0,
                                            is_full_day:0
                                        }))} 
                                        className="m-1" />
                                        Till
                                    </Label>
                                    <Label className="d-flex align-items-center m-1">
                                        <Input type="time" 
                                        value={state.from_timing}
                                        onChange={(e) => setState((pre) => ({...pre,
                                            from_timing: e.target.value
                                        }))} 
                                        className="m-1" />
                                    </Label>
                                    <Label className="d-flex align-items-center m-1">
                                        <Input type="time" 
                                        value={state.till_time}
                                        onChange={(e) => setState((pre) => ({...pre,
                                            till_time: e.target.value
                                        }))} 
                                        className="m-1" />
                                    </Label>
                                </FormGroup>
                            </Col>
                            <Col md={12}>
                                <FormGroup  className="d-flex align-items-center">
                                    <Label className="d-flex align-items-center m-1">
                                        <Input type="checkbox" 
                                        checked={state.is_advence_booking === 1}
                                        onChange={(e) => setState((pre) => ({...pre,
                                            is_advence_booking: e.target.checked ? 1: 0
                                        }))} 
                                        className="m-1" />
                                        Advance Booking
                                    </Label>
                                    <fieldset className="m-2">
                                        <Label className="text-black">Start Date</Label>
                                        <Input type="date" 
                                        value={state.adv_start_date} 
                                        onChange={(e) => setState((pre) => ({...pre,
                                            adv_start_date: e.target.value
                                        }))} 
                                        className="m-1" />
                                    </fieldset>
                                    <fieldset className="m-2">
                                        <Label className="text-black">End Date</Label>
                                        <Input type="date" 
                                        value={state.adv_end_date} 
                                        onChange={(e) => setState((pre) => ({...pre,
                                            adv_end_date: e.target.value
                                        }))} 
                                        className="m-1" />
                                    </fieldset>
                                </FormGroup>
                            </Col>
                            <Col md={12}>
                                <FormGroup  className="d-flex align-items-center">
                                    {/* <Label className="d-flex align-items-center m-1">
                                        Time frame
                                    </Label> */}
                                    <fieldset className="m-2">
                                        <Label className="text-black">Time Frame</Label>
                                        <Input type="text" 
                                        value={state.time_frame} 
                                        onChange={(e) => setState((pre) => ({...pre,
                                            time_frame: e.target.value
                                        }))} 
                                        className="m-1" />
                                    </fieldset>
                                    <fieldset className="m-2">
                                        <Label className="text-black">Time Frame Type</Label>
                                        <Input type="select" name="timeFrameType" 
                                            value={state.time_frame_type} 
                                            onChange={(e)=> {
                                                    setState((prev)=>({
                                                        ...prev,
                                                        time_frame_type: e.target.value,
                                                    }));
                                                }
                                            }
                                            >
                                            <option value="">Select Ticket Type</option>
                                            {['Days','Week','Month']?.map((item,i) => (
                                                <option key={i} value={item}>{item}</option>
                                            ))}
                                        </Input>
                                    </fieldset>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Col>
                </>
            )}
            <AdditionalFormFields addFormType={'timings'} placeId={placeId}/>
            <Button color="success" 
            onClick={handleSubmit} 
            className="mt-3 w-100">
                Submit
            </Button>
        </div>
    );
};

export default Timings;
